import axios from "axios";

const csrfToken =
  (window.Hupe8 && window.Hupe8.token) ||
  document.querySelector('meta[name="csrf-token"]')?.content ||
  "";

const api = axios.create();
if (csrfToken) api.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

export const listDefaultBenefits = (state = "active") =>
  api.get("/api/default_benefits", { params: { state } });

export const saveDefaultBenefit = (benefit, data, cb) => {
  const method = benefit ? "patch" : "post";
  const url    = benefit
    ? `/api/default_benefits/${benefit.id}`
    : "/api/default_benefits";

  api({ method, url, data })
    .then(r => cb(r))
    .catch(e => cb(e.response || {}));
};

export const switchState = (id, data, cb) =>
  api.patch(`/api/default_benefits/${id}/switch_state`, data)
    .then(r => cb(r))
    .catch(e => cb(e.response || {}));

export const deleteBenefit = (id, cb) =>
  api.delete(`/api/default_benefits/${id}`)
    .then(r => cb(r))
    .catch(e => cb(e.response || {}));
